/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { RoleDTO } from '../model/roleDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RoleResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countRoles
     * 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param permissionIdEquals 
     * @param permissionIdGreaterThan 
     * @param permissionIdGreaterThanOrEqual 
     * @param permissionIdIn 
     * @param permissionIdLessThan 
     * @param permissionIdLessThanOrEqual 
     * @param permissionIdNotEquals 
     * @param permissionIdSpecified 
     * @param roleCodeContains 
     * @param roleCodeDoesNotContain 
     * @param roleCodeEquals 
     * @param roleCodeIn 
     * @param roleCodeNotEquals 
     * @param roleCodeSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (permissionIdEquals !== undefined && permissionIdEquals !== null) {
            queryParameters = queryParameters.set('permissionId.equals', <any>permissionIdEquals);
        }
        if (permissionIdGreaterThan !== undefined && permissionIdGreaterThan !== null) {
            queryParameters = queryParameters.set('permissionId.greaterThan', <any>permissionIdGreaterThan);
        }
        if (permissionIdGreaterThanOrEqual !== undefined && permissionIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('permissionId.greaterThanOrEqual', <any>permissionIdGreaterThanOrEqual);
        }
        if (permissionIdIn) {
            permissionIdIn.forEach((element) => {
                queryParameters = queryParameters.append('permissionId.in', <any>element);
            })
        }
        if (permissionIdLessThan !== undefined && permissionIdLessThan !== null) {
            queryParameters = queryParameters.set('permissionId.lessThan', <any>permissionIdLessThan);
        }
        if (permissionIdLessThanOrEqual !== undefined && permissionIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('permissionId.lessThanOrEqual', <any>permissionIdLessThanOrEqual);
        }
        if (permissionIdNotEquals !== undefined && permissionIdNotEquals !== null) {
            queryParameters = queryParameters.set('permissionId.notEquals', <any>permissionIdNotEquals);
        }
        if (permissionIdSpecified !== undefined && permissionIdSpecified !== null) {
            queryParameters = queryParameters.set('permissionId.specified', <any>permissionIdSpecified);
        }
        if (roleCodeContains !== undefined && roleCodeContains !== null) {
            queryParameters = queryParameters.set('roleCode.contains', <any>roleCodeContains);
        }
        if (roleCodeDoesNotContain !== undefined && roleCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('roleCode.doesNotContain', <any>roleCodeDoesNotContain);
        }
        if (roleCodeEquals !== undefined && roleCodeEquals !== null) {
            queryParameters = queryParameters.set('roleCode.equals', <any>roleCodeEquals);
        }
        if (roleCodeIn) {
            roleCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('roleCode.in', <any>element);
            })
        }
        if (roleCodeNotEquals !== undefined && roleCodeNotEquals !== null) {
            queryParameters = queryParameters.set('roleCode.notEquals', <any>roleCodeNotEquals);
        }
        if (roleCodeSpecified !== undefined && roleCodeSpecified !== null) {
            queryParameters = queryParameters.set('roleCode.specified', <any>roleCodeSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/m8t/api/roles/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createRole
     * 
     * @param body roleDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRoleUsingPOST(body: RoleDTO, observe?: 'body', reportProgress?: boolean): Observable<RoleDTO>;
    public createRoleUsingPOST(body: RoleDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDTO>>;
    public createRoleUsingPOST(body: RoleDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDTO>>;
    public createRoleUsingPOST(body: RoleDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createRoleUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleDTO>('post',`${this.basePath}/m8t/api/roles`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteRole
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRoleUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteRoleUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteRoleUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteRoleUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteRoleUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/m8t/api/roles/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllRoles
     * 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param nameContains 
     * @param nameDoesNotContain 
     * @param nameEquals 
     * @param nameIn 
     * @param nameNotEquals 
     * @param nameSpecified 
     * @param page Page number of the requested page
     * @param permissionIdEquals 
     * @param permissionIdGreaterThan 
     * @param permissionIdGreaterThanOrEqual 
     * @param permissionIdIn 
     * @param permissionIdLessThan 
     * @param permissionIdLessThanOrEqual 
     * @param permissionIdNotEquals 
     * @param permissionIdSpecified 
     * @param roleCodeContains 
     * @param roleCodeDoesNotContain 
     * @param roleCodeEquals 
     * @param roleCodeIn 
     * @param roleCodeNotEquals 
     * @param roleCodeSpecified 
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<RoleDTO>>;
    public getAllRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RoleDTO>>>;
    public getAllRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RoleDTO>>>;
    public getAllRolesUsingGET(idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, nameContains?: string, nameDoesNotContain?: string, nameEquals?: string, nameIn?: Array<string>, nameNotEquals?: string, nameSpecified?: boolean, page?: number, permissionIdEquals?: number, permissionIdGreaterThan?: number, permissionIdGreaterThanOrEqual?: number, permissionIdIn?: Array<number>, permissionIdLessThan?: number, permissionIdLessThanOrEqual?: number, permissionIdNotEquals?: number, permissionIdSpecified?: boolean, roleCodeContains?: string, roleCodeDoesNotContain?: string, roleCodeEquals?: string, roleCodeIn?: Array<string>, roleCodeNotEquals?: string, roleCodeSpecified?: boolean, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (nameContains !== undefined && nameContains !== null) {
            queryParameters = queryParameters.set('name.contains', <any>nameContains);
        }
        if (nameDoesNotContain !== undefined && nameDoesNotContain !== null) {
            queryParameters = queryParameters.set('name.doesNotContain', <any>nameDoesNotContain);
        }
        if (nameEquals !== undefined && nameEquals !== null) {
            queryParameters = queryParameters.set('name.equals', <any>nameEquals);
        }
        if (nameIn) {
            nameIn.forEach((element) => {
                queryParameters = queryParameters.append('name.in', <any>element);
            })
        }
        if (nameNotEquals !== undefined && nameNotEquals !== null) {
            queryParameters = queryParameters.set('name.notEquals', <any>nameNotEquals);
        }
        if (nameSpecified !== undefined && nameSpecified !== null) {
            queryParameters = queryParameters.set('name.specified', <any>nameSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (permissionIdEquals !== undefined && permissionIdEquals !== null) {
            queryParameters = queryParameters.set('permissionId.equals', <any>permissionIdEquals);
        }
        if (permissionIdGreaterThan !== undefined && permissionIdGreaterThan !== null) {
            queryParameters = queryParameters.set('permissionId.greaterThan', <any>permissionIdGreaterThan);
        }
        if (permissionIdGreaterThanOrEqual !== undefined && permissionIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('permissionId.greaterThanOrEqual', <any>permissionIdGreaterThanOrEqual);
        }
        if (permissionIdIn) {
            permissionIdIn.forEach((element) => {
                queryParameters = queryParameters.append('permissionId.in', <any>element);
            })
        }
        if (permissionIdLessThan !== undefined && permissionIdLessThan !== null) {
            queryParameters = queryParameters.set('permissionId.lessThan', <any>permissionIdLessThan);
        }
        if (permissionIdLessThanOrEqual !== undefined && permissionIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('permissionId.lessThanOrEqual', <any>permissionIdLessThanOrEqual);
        }
        if (permissionIdNotEquals !== undefined && permissionIdNotEquals !== null) {
            queryParameters = queryParameters.set('permissionId.notEquals', <any>permissionIdNotEquals);
        }
        if (permissionIdSpecified !== undefined && permissionIdSpecified !== null) {
            queryParameters = queryParameters.set('permissionId.specified', <any>permissionIdSpecified);
        }
        if (roleCodeContains !== undefined && roleCodeContains !== null) {
            queryParameters = queryParameters.set('roleCode.contains', <any>roleCodeContains);
        }
        if (roleCodeDoesNotContain !== undefined && roleCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('roleCode.doesNotContain', <any>roleCodeDoesNotContain);
        }
        if (roleCodeEquals !== undefined && roleCodeEquals !== null) {
            queryParameters = queryParameters.set('roleCode.equals', <any>roleCodeEquals);
        }
        if (roleCodeIn) {
            roleCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('roleCode.in', <any>element);
            })
        }
        if (roleCodeNotEquals !== undefined && roleCodeNotEquals !== null) {
            queryParameters = queryParameters.set('roleCode.notEquals', <any>roleCodeNotEquals);
        }
        if (roleCodeSpecified !== undefined && roleCodeSpecified !== null) {
            queryParameters = queryParameters.set('roleCode.specified', <any>roleCodeSpecified);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<RoleDTO>>('get',`${this.basePath}/m8t/api/roles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getRole
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoleUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<RoleDTO>;
    public getRoleUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDTO>>;
    public getRoleUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDTO>>;
    public getRoleUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRoleUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RoleDTO>('get',`${this.basePath}/m8t/api/roles/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateRole
     * 
     * @param body roleDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRoleUsingPUT(body: RoleDTO, observe?: 'body', reportProgress?: boolean): Observable<RoleDTO>;
    public updateRoleUsingPUT(body: RoleDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RoleDTO>>;
    public updateRoleUsingPUT(body: RoleDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RoleDTO>>;
    public updateRoleUsingPUT(body: RoleDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateRoleUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<RoleDTO>('put',`${this.basePath}/m8t/api/roles`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
